import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import type {
  ApiSocialMedia,
  UiSocialMedia,
} from '../../schemas/socialMedia.schema';

const DEFAULT_SOCIAL_MEDIA = [
  { type: 'FACEBOOK', url: '' },
  { type: 'INSTAGRAM', url: '' },
  { type: 'LINKEDIN', url: '' },
  { type: 'TIKTOK', url: '' },
  { type: 'TWITTER', url: '' },
  { type: 'YOUTUBE', url: '' },
] as UiSocialMedia[];

export function mergeDefaultSocialMedia(socialMedia: UiSocialMedia[]) {
  return uniqBy(
    [...sortBy(socialMedia, 'type'), ...DEFAULT_SOCIAL_MEDIA],
    'type',
  ).filter((item) => item.type);
}

export function mapSocialMediaFromApi(
  socialMedia: ApiSocialMedia,
): UiSocialMedia {
  return {
    type: socialMedia.type,
    url: socialMedia.url,
  };
}
